import { BB_APPLICATION_ENDPOINT, buildUrl } from "../config/urls";
import { fetcher } from "../helpers/fetcher";

export interface CandidateData {
  candidateId: string;
  sfCandidateId: string;
}

const cachedRequests: Record<string, Promise<CandidateData>> = {};

export const getCandidateData = (
  applicationId?: string
): Promise<CandidateData> => {
  if (process.env.NODE_ENV === "development") {
    if (process.env.REACT_APP_USE_MOCK_REQUESTS === "true") {
      console.warn(
        "getCandidateData",
        BB_APPLICATION_ENDPOINT,
        "mocked request",
        applicationId
      );
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            candidateId: "1",
            sfCandidateId: "1",
          });
          // reject(new ServerError("", 404));
        }, 1000);
      });
    }
  }
  if (!applicationId) {
    throw new Error("applicationId should be provided");
  }
  if (!cachedRequests[applicationId]) {
    const url = buildUrl(BB_APPLICATION_ENDPOINT, {
      applicationId,
    });
    cachedRequests[applicationId] = fetcher(url);
  }
  return cachedRequests[applicationId];
};
